import { render, staticRenderFns } from "./navi.vue?vue&type=template&id=4b1c69c8&"
import script from "./navi.vue?vue&type=script&lang=js&"
export * from "./navi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports